import { render, staticRenderFns } from "./fixedThead.vue?vue&type=template&id=554ca76f"
import script from "./fixedThead.vue?vue&type=script&lang=js"
export * from "./fixedThead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports